import React, { useState, useEffect } from 'react';
import { Button, Card, Select, MenuItem, InputLabel, TextField, FormControl, Box, Autocomplete, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Backdrop } from '@mui/material';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { BASE_URL } from '../../App';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';

const reportTypeData = [
    { label: 'CASC Code Mapping Report', value: 'C' },
    { label: 'DASC Code Mapping Report', value: 'D' },
];

const ASC_Mapping_Report = () => {
    const [branch, setBranch] = useState([]);
    const [reportType, setReportType] = useState('C');
    const [viewTable, setViewTable] = useState(false);
    const [branchData, setBranchData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [branchOptions, setbranchOptions] = useState([]);
    const [error, setError] = useState('');
    const login_id = localStorage.getItem("LOGIN_ID");
    const usergroup_code = localStorage.getItem("GROUP_CODE");


    useEffect(() => {
        fetchbranchOptions();
    }, []);

    const fetchbranchOptions = async () => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + '/getBranchforASC', {
                loginId: login_id,
                usergroup_code: usergroup_code,
            });

            if (response.data?.ddlBranch) {
                const branchOptions = Array.isArray(response.data.ddlBranch) ? response.data.ddlBranch : [];
                const allOption = { BRANCHNAME: 'ALL', BRANCH: 'ALL' };
                setbranchOptions([allOption, ...branchOptions]);
            } else {
                setErrorMessage("No Dealer options available.");
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    const handleViewTable = async () => {
        setLoading(true);
        setErrorMessage('');
        setTableData([]);
        try {
            const response = await axios.post(BASE_URL + '/getascreportdata', {
                loginId: login_id,
                branch: branch?.BRANCH,
                reportType: reportType,
            });

            let responseData = response.data?.data;
            if (Array.isArray(responseData)) {
                responseData = responseData.flat();
            }

            if (responseData && Array.isArray(responseData) && responseData.length > 0) {
                const mappedData = responseData.map(item => ({
                    branch: item.Branch,
                    dealer_code: item["Dealer Code"],
                    dealer_name: item["Dealer Name"],
                    dealer_category: item["Dealer Category"],
                    dealer_address: item["Dealer Address"],
                    dealer_city: item["Dealer City"],
                    dealer_state: item["Dealer State"],
                    dealer_pincode: item["Dealer Pincode"],
                    asc_code: item["ASC Code"],
                    asc_name: item["ASC Name"],
                    asc_address: item["ASC Address"],
                    asc_city: item["ASC City"],
                    asc_pincode: item["ASC Pincode"],
                }));

                setTableData(mappedData);
                setViewTable(true);
                setErrorMessage('');
            } else {
                setViewTable(true);
            }
        } catch (error) {
            console.error("Error fetching data:", error.response?.data || error.message);
            setErrorMessage('Error fetching table data.');
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = () => {
        if (tableData.length === 0) {
            Swal.fire({
                icon: 'info',
                text: 'No Data Available For export!',
            });
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to download the Excel file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, download it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Preparing download...',
                    text: 'Please wait while we prepare your report.',
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    allowOutsideClick: false,
                    showConfirmButton: false,
                });

                setTimeout(() => {
                    const ws = XLSX.utils.json_to_sheet(tableData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Report');
                    XLSX.writeFile(wb, `report_${branch}_${reportType}.xlsx`);
                    Swal.close();
                }, 1000);
            }
        });
    };

    return (
        <Box sx={{ padding: 4 }}>
            <Grid container justifyContent="flex-start" sx={{ marginBottom: 3 }}>
                <Grid item xs={12} md={8}>
                    <Card sx={{ padding: 3, width: '100%' }}>
                        <Grid container justifyContent="flex-start" spacing={3} sx={{ marginBottom: 3 }} direction="row" alignItems="center">
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    disablePortal
                                    onChange={(event, newValue) => {
                                        setBranch(newValue ? { branchName: newValue.BRANCHNAME, branchCode: newValue.BRANCH } : null);
                                    }}
                                    options={branchOptions}
                                    getOptionLabel={(option) => {
                                        if (option.BRANCH === 'ALL') {
                                            return 'ALL';
                                        }
                                        return `${option.BRANCH} - ${option.BRANCHNAME}`;
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Branch" sx={{ width: '100%' }} />
                                    )}
                                />
                            </Grid>


                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="reporttype-select-label">Select Report Type</InputLabel>
                                    <Select
                                        labelId="reporttype-select-label"
                                        value={reportType}
                                        onChange={(e) => setReportType(e.target.value)}
                                        label="Select Report Type"
                                        sx={{ width: '100%' }}
                                    >
                                        {reportTypeData.map((item, index) => (
                                            <MenuItem key={index} value={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container justifyContent="flex-start" spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleViewTable}
                                    sx={{ marginRight: 2 }}
                                    disabled={loading || !branch || !reportType}
                                >
                                    {loading ? <CircularProgress size={24} /> : 'View'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleDownload}
                                    sx={{
                                        backgroundColor: 'green',
                                        '&:hover': { backgroundColor: 'darkgreen' },
                                    }}
                                    disabled={loading || tableData.length === 0}
                                >
                                    {loading ? <CircularProgress size={24} /> : 'Download as Excel'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress size={40} color="success" />
            </Backdrop>

            {errorMessage && (
                <Typography color="error" sx={{ textAlign: 'center', marginTop: 3 }}>
                    {errorMessage}
                </Typography>
            )}

            {viewTable && (
                <Grid container justifyContent="flex-start" sx={{ marginTop: 3 }}>
                    <Grid item xs={12}>
                        <TableContainer sx={{ maxHeight: 450, overflowY: 'auto' }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Branch</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer Code</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer Name</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer Category</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer Address</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer City</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer State</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>Dealer Pincode</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>ASC Code</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>ASC Name</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>ASC Address</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>ASC City</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold', color: 'white', backgroundColor: '#1976d2' }}>ASC Pincode</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.length > 0 ? (
                                        tableData.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.branch}</TableCell>
                                                <TableCell>{row.dealer_code}</TableCell>
                                                <TableCell>{row.dealer_name}</TableCell>
                                                <TableCell>{row.dealer_category}</TableCell>
                                                <TableCell>{row.dealer_address}</TableCell>
                                                <TableCell>{row.dealer_city}</TableCell>
                                                <TableCell>{row.dealer_state}</TableCell>
                                                <TableCell>{row.dealer_pincode}</TableCell>
                                                <TableCell>{row.asc_code}</TableCell>
                                                <TableCell>{row.asc_name}</TableCell>
                                                <TableCell>{row.asc_address}</TableCell>
                                                <TableCell>{row.asc_city}</TableCell>
                                                <TableCell>{row.asc_pincode}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={12} align="center">
                                                No data available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};

export default ASC_Mapping_Report;










































